import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Store from './Store';
import {Provider} from 'react-redux';

ReactDOM.render(<Provider store={Store}><App/></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// Dynamically load plugin.js using the env variable
const commonComponentUrl = process.env.REACT_APP_URL_CommonComponent;
if (commonComponentUrl) {
	const normalizedBaseUrl = commonComponentUrl.replace(/\/$/, "");
	const script = document.createElement("script");
	script.src = `${normalizedBaseUrl}/plugin.js`;
	script.async = true;
	document.body.appendChild(script);
}

const statsScript = document.createElement("script");
statsScript.src = `https://duhkahawczku4.cloudfront.net/vera/${process.env.REACT_APP_BUILD}/current/plugin.iife.js`;
statsScript.async = true;
document.body.appendChild(statsScript);
serviceWorker.unregister();
